import { render, staticRenderFns } from "./identifiersComponent.vue?vue&type=template&id=d5822df2&scoped=true&"
import script from "./identifiersComponent.vue?vue&type=script&lang=js&"
export * from "./identifiersComponent.vue?vue&type=script&lang=js&"
import style0 from "./identifiersComponent.vue?vue&type=style&index=0&id=d5822df2&prod&lang=scss&scoped=true&"
import style1 from "./identifiersComponent.vue?vue&type=style&index=1&id=d5822df2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5822df2",
  null
  
)

export default component.exports